import Container from './Container';
import Column    from './Column';
import Row       from './Row';

type TypeResponsiveView = {
  Container: typeof Container;
  Column   : typeof Column   ;
  Row      : typeof Row      ;
}

const ResponsiveView: TypeResponsiveView = {
  Container,
  Column   ,
  Row      ,
};

export default ResponsiveView;
